
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/052625",
      function () {
        return require("private-next-pages/news-and-events/052625.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/052625"])
      });
    }
  